import { link } from "@/components/Action.tsx";
import type { StorageAccountWithType } from "@/modules/storage/account/storageAccountApi.ts";
import type { BucketWithType } from "@/modules/storage/bucket/bucketApi";

export function bucketLink({ name: storageName }: BucketWithType) {
    return link({ to: "/storage/bucket/$storageName", params: { storageName } });
}

export function storageAccountLink({ uuid: accountUuid }: StorageAccountWithType) {
    return link({ to: "/storage/account/$accountUuid", params: { accountUuid } });
}
